'use client'

import { useState } from 'react'
import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  reserveTransactionItems,
  TransactionModel,
} from '@marketplace-web/messaging/conversation-messaging-data'

import ConfirmModal from '../../../../ConfirmModal'

type Props = {
  transaction?: TransactionModel | null
}

const Unreserve = ({ transaction }: Props) => {
  const translate = useTranslate('conversation.hero_message')

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleUnreserveClick = () => setIsModalVisible(true)

  const handleRemoveReservationModalConfirmClick = async () => {
    if (!transaction?.order || isLoading) return

    setIsLoading(true)

    await reserveTransactionItems(transaction.id, false)

    setIsLoading(false)

    setIsModalVisible(false)
  }

  const handleRemoveReservationModalCancelClick = () => {
    setIsModalVisible(false)
  }

  const renderRemoveReservationModal = () => {
    return (
      <ConfirmModal
        show={isModalVisible}
        theme="primary"
        translationsPrefix="conversation.conversation_info.remove_reservation_modal"
        onConfirm={handleRemoveReservationModalConfirmClick}
        onCancel={handleRemoveReservationModalCancelClick}
      />
    )
  }

  const renderUnreserveButton = () => {
    if (!transaction) return null

    return (
      <Button
        text={translate('transaction_actions.unreserve')}
        size={Button.Size.Medium}
        onClick={handleUnreserveClick}
        testId="unreserve-button"
      />
    )
  }

  return (
    <>
      {renderUnreserveButton()}
      {renderRemoveReservationModal()}
    </>
  )
}

export default Unreserve
